import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import CheckboxGroup from "../../ui/molecules/CheckBoxGroup";
import { setCustomerCreateRequestField, setCustomerUpdateRequestField } from "../clienti/feature/slice";

interface Props {
    mode?: "create" | "edit"
}

export function QualitaSicura({ mode }: Props) {
    const customerState = useAppSelector((state) => state.customer);
    const dispatch = useAppDispatch()

    enum ProdChainType {
        FILIERA_BOVINA = "FILIERA_BOVINA",
        FILIERA_GRANO_DURO_E_DERIVATI = "FILIERA_GRANO_DURO_E_DERIVATI",
        FILIERA_AGNELLO_AGNELLONE = "FILIERA_AGNELLO_AGNELLONE",
        FILIERA_LATTE_CRUDO_VACCINO_E_DERIVATI = "FILIERA_LATTE_CRUDO_VACCINO_E_DERIVATI"
    }
    const [selectedTypes, setSelectedTypes] = useState<ProdChainType[]>([]);

    useEffect(() => {
        if (customerState.getCustomerByIdResponse !== undefined && mode === "edit") {
            dispatch(setCustomerUpdateRequestField({ field: "sqProductionChain", value: customerState.getCustomerByIdResponse.sqnpiSubjectType }));
            const productionChain = customerState.getCustomerByIdResponse.sqProductionChain.map((type: string) => ProdChainType[type as keyof typeof ProdChainType]);
            setSelectedTypes(productionChain);
        }
    }, [customerState.getCustomerByIdResponse, mode]);

    const handleTypesChange = (value: ProdChainType) => {
        let currentTypes = [...selectedTypes];
        if (currentTypes.includes(value)) {
            currentTypes = currentTypes.filter(t => t !== value);
            //setSelectedTypes(currentTypes.filter(t => t !== value))
            //dispatch(setSqProductionChain(selectedTypes))
        }
        else {
            currentTypes.push(value)
            //setSelectedTypes(currentTypes)
        }
        setSelectedTypes(currentTypes);
        if (mode === "create")
            dispatch(setCustomerCreateRequestField({ field: "sqProductionChain", value: currentTypes }))
        else
            dispatch(setCustomerUpdateRequestField({ field: "sqProductionChain", value: currentTypes }))
    }

    return (
        <div className="border-t border-neutral-200 pt-6 flex flex-col gap-3">
            <span className="text-center text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Tipo Adesione</span>
            <CheckboxGroup
                name="tipo_adesione"
                options={Object.values(ProdChainType)}
                selectedValues={selectedTypes}
                onChange={handleTypesChange}
                optionLabels={{
                    [ProdChainType.FILIERA_BOVINA]: "Filiera Bovina",
                    [ProdChainType.FILIERA_GRANO_DURO_E_DERIVATI]: "Filiera Grano Duro e Derivati",
                    [ProdChainType.FILIERA_AGNELLO_AGNELLONE]: "Filiera Agnello / Agnellone",
                    [ProdChainType.FILIERA_LATTE_CRUDO_VACCINO_E_DERIVATI]: "Filiera Latte Crudo, Vaccino e Derivati"
                }}
            />
        </div>
    )
}